import { useTranslation } from "react-i18next";

import { QuoteTabType } from "../../../models/Lead";
import classNames from "../../../utils/classNames";

export const QUOTE_TYPE_TABS = [
  { key: QuoteTabType.Quotes, label: "Quotes" },
  { key: QuoteTabType.Atf, label: "ATF Quotes"},
  { key: QuoteTabType.HighValue, label: "High Value Quotes" },
  { key: QuoteTabType.HighPriority, label: "High Priority" },
  { key: QuoteTabType.ManagerAssistance, label: "Manager Assistance" },
];

export default function QuoteTypeTabs({
  activeTab,
  setActiveTab,
  tabCounts = {},
  showAtfTab = false,
}: {
  activeTab: QuoteTabType;
  setActiveTab: (tab: QuoteTabType) => void;
  tabCounts?: Partial<Record<QuoteTabType, number>>;
  /** ATF allocation is SAV's alone, so only SAV sees the ATF tab. */
  showAtfTab?: boolean;
}) {
  const { t } = useTranslation("leads");

  const tabs = showAtfTab
    ? QUOTE_TYPE_TABS
    : QUOTE_TYPE_TABS.filter((tab) => tab.key !== QuoteTabType.Atf);

  return (
    <div className="border-b border-gray-200">
      <nav className="flex gap-1" aria-label={t("Quote tabs")}>
        {tabs.map((tab) => (
          <button
            key={tab.key}
            type="button"
            onClick={() => setActiveTab(tab.key)}
            className={classNames(
              "px-4 py-2.5 text-sm font-medium rounded-t-lg border border-b-0 transition-colors flex items-center gap-1.5",
              activeTab === tab.key
                ? "bg-white text-primary-700 border-gray-200 shadow-sm -mb-px"
                : "bg-gray-50 text-gray-500 border-transparent hover:text-gray-700 hover:bg-gray-100"
            )}
          >
            {t(tab.label)}
            <span className={classNames(
              "inline-flex items-center justify-center min-w-[20px] h-5 rounded-full px-1.5 text-[11px] font-bold",
              activeTab === tab.key
                ? "bg-primary-100 text-primary-700"
                : "bg-gray-200 text-gray-600"
            )}>
              {tabCounts[tab.key] ?? 0}
            </span>
          </button>
        ))}
      </nav>
    </div>
  )
}